"use strict";

exports.__esModule = true;
exports.ClassificationSelector = ClassificationSelector;
var _react = _interopRequireDefault(require("react"));
var _core = require("@blueprintjs/core");
var _icons = require("@blueprintjs/icons");
var _ClassificationContext = require("../../Operator/ClassificationContext");
var _ClassificationSelectorMenu = require("./ClassificationSelectorMenu");
var _ClassificationSelectorIcon = require("./ClassificationSelectorIcon");
var _PlantStateActivities = require("../../PlantStateActivities");
var _excluded = ["plantStateActivities", "activityPredicate", "onChange", "children", "selected"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
/**
 * A button which shows a classification menu in a popover.
 */
function ClassificationSelector(props) {
  var classification = _react["default"].useContext(_ClassificationContext.ClassificationContext);
  var plantStateActivities = props.plantStateActivities,
    _props$activityPredic = props.activityPredicate,
    activityPredicate = _props$activityPredic === void 0 ? function () {
      return true;
    } : _props$activityPredic,
    onChange = props.onChange,
    children = props.children,
    selected = props.selected,
    extra = _objectWithoutPropertiesLoose(props, _excluded);
  var element;
  if (selected && selected.state) {
    var selectedState = (0, _PlantStateActivities.getPlantState)(plantStateActivities.states, selected.state);
    var selectedActivity = selected.activity ? (0, _PlantStateActivities.getPlantActivity)(plantStateActivities.activities, selected.activity) : null;
    if (selectedState) {
      element = /*#__PURE__*/_react["default"].createElement(_core.Button, _extends({
        icon: /*#__PURE__*/_react["default"].createElement(_ClassificationSelectorIcon.ClassificationSelectorIcon, {
          state: selectedState
        }),
        text: selectedActivity ? selectedState.name + ": " + selectedActivity.name : selectedState.name
      }, extra));
    }
  }
  if (!element) {
    element = /*#__PURE__*/_react["default"].createElement(_core.Button, _extends({
      icon: _icons.IconNames.MENU,
      text: children
    }, extra));
  }
  return /*#__PURE__*/_react["default"].createElement(_core.Popover, {
    content: /*#__PURE__*/_react["default"].createElement(_ClassificationSelectorMenu.ClassificationSelectorMenu, {
      classification: classification,
      onClick: onChange,
      plantStateActivities: plantStateActivities,
      activityPredicate: activityPredicate
    }),
    position: _core.Position.RIGHT,
    popoverClassName: "vi-select-popover",
    usePortal: true
  }, element);
}